import styled from 'styled-components';

export const Container = styled.div`
  .history-arrow {
    font-size: 0.7em;
  }

  .result-container {
    transition: all 1s;
  }
  .color {
    color: ${(props) => props.theme.$dark_light};
    font-size: 24px;
  }

  .estimated {
    color: #ff8000 !important;
  }

  .nav-arrow {
    filter: invert(17%) sepia(92%) saturate(2476%) hue-rotate(206deg) brightness(92%) contrast(101%);
  }

  .background-state {
    background: ${(props) => props.theme.$info};
    color: ${(props) => props.theme.$white};
    padding: 3px 5px;
  }

  .background-date {
    background: ${(props) => props.theme.$gray200};
    border-radius: 4px;
    margin-left: -7px;
    margin-right: -7px;
  }

  .backgroud-contracts {
    background-color: ${(props) => props.theme.$gray200};
    color: ${(props) => props.theme.$gray700};
  }

  .font-color-more {
    color: ${(props) => props.theme.$gray600};
  }

  .font-color-title {
    color: ${(props) => props.theme.$dark};
  }

  .databalloon[aria-label] {
    overflow: visible;
  }

  .bidding {
    border-top-left-radius: 0;

    &-bg-header {
      background: ${(props) => props.theme.$dark};
      border-top-left-radius: 0 !important;
    }

    .card-header {
      .item {
        color: ${(props) => props.theme.$white};

        &-label {
          color: ${(props) => props.theme.$white};
        }
      }
    }

    &-keyword {
      background: ${(props) => props.theme.$keyword};
    }

    &.bidding_selected {
      .bidding-bg-header {
        border-top-left-radius: 0;
      }

      border-top-left-radius: 0;
      border-bottom-left-radius: 0;

      &::before {
        content: '';
        width: 7px;
        height: 100%;
        background: ${(props) => props.theme.$primary_green_light};
        position: absolute;
        left: -7px;
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;

        @media print {
          display: none;
        }
      }
    }

    .bidding-bg-header {
      background: ${(props) => props.theme.$dark};
      border-top-left-radius: 0 !important;
    }

    @media print {
      canvas.chartjs-render-monitor {
        min-height: 100%;
        max-width: 100%;
        max-height: 100%;
        height: auto !important;
        width: auto !important;
      }
    }

    @media only screen and (max-width: 768px) {
      .contract-list div::before {
        font-weight: bold;
        margin-right: 0.4em;
        color: ${(props) => props.theme.$dark};
      }

      .contract-list div:nth-child(1)::before {
        content: 'Nome:';
      }

      .contract-list div:nth-child(2)::before {
        content: 'Data:';
      }

      .contract-list div:nth-child(3)::before {
        content: 'Tipo:';
      }
    }
  }
`;

export const ModalHeader = styled.div`
  background: ${({ theme }) => theme.$dark};
  color: white;
`;

export const ModalScroll = styled.div`
  max-height: 70vh;
  overflow-y: auto;
`;
